import { Rect } from 'react-konva';
import { Size } from '../../../../core/types/ui/size';
import { IPosition2d } from '../../../../core/types/ui/position';
import { UseSheetTheme } from '../../../hooks/useSheetTheme';
import { UseCellSelection } from '../../../hooks/useCellSelection';
import { SelectionCell } from '../../../types';

interface ColumnHeaderRootProps
  extends Size,
    IPosition2d,
    Pick<UseCellSelection, 'onCellMouseDown'>,
    Pick<UseSheetTheme, 'fill' | 'stroke'> {}
const ColumnHeaderRoot: React.FC<ColumnHeaderRootProps> = ({
  x,
  y,
  width,
  height,
  fill,
  stroke,
  onCellMouseDown,
}) => {
  return (
    <Rect
      x={x}
      y={y}
      width={width}
      height={height}
      fill={fill}
      stroke={stroke}
      strokeWidth={1}
      onMouseDown={(e) =>
        onCellMouseDown(e, SelectionCell.Root, { ci: 0, ri: 0 })
      }
    />
  );
};

export default ColumnHeaderRoot;
